import { useSearchParams } from 'react-router-dom';

export const useHideChrome = () => {
  const [searchParams] = useSearchParams();
  return searchParams.has('ResourceOnly');
};
